import * as STRING_DEFINE from "@/misc/stringDefine";

export default function (key, defineKey) {
  return STRING_DEFINE[defineKey] && STRING_DEFINE[defineKey][key] ? STRING_DEFINE[defineKey][key] : key;
}
